import { Box } from "@mantine/core";
import type { SectorAdmin } from "../useSectorPermissions";
import { formatAdminFirstNames } from "../formatAdminFirstNames";
import classes from "./index.module.css";

type SectorAdminsLineProps = {
  admins: readonly SectorAdmin[];
  className?: string;
};

/**
 * "Administradores da conta: Ana, Bruno", a quem o membro pede acesso. Mesma
 * linha no bloqueio de página (FeatureGate) e onde uma ação é só de admin
 * (ex.: conectar o WhatsApp). Sem nenhum admin com nome, não renderiza nada.
 */
export function SectorAdminsLine({ admins, className }: SectorAdminsLineProps) {
  const names = formatAdminFirstNames(admins);
  if (!names) return null;

  return (
    <Box
      component="p"
      className={className ? `${classes.line} ${className}` : classes.line}>
      <Box
        component="span"
        className={classes.label}>
        Administradores da conta:
      </Box>{" "}
      <Box
        component="span"
        className={classes.names}>
        {names}
      </Box>
    </Box>
  );
}

export default SectorAdminsLine;
